// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wd8JH","controls":"styles_controls__IV1C0","charLimit":"styles_charLimit__2RGvU","input":"styles_input__3aRAV","send":"styles_send__1ntrH"};